import { Injectable, signal } from '@angular/core';
import { ChatMessage } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ChatStore {
  public readonly loading = signal(false);

  public readonly messages = signal<ChatMessage[]>([]);

  public readonly sessionId = signal<string | null>(null);

  /** Bumped every time a new chat session starts; lets in-flight requests detect they've been superseded. */
  public readonly conversationGeneration = signal(0);

  public addMessage(message: ChatMessage): void {
    this.messages.update((messages) => [...messages, message]);
  }

  public setMessages(messages: ChatMessage[]): void {
    this.messages.set(messages);
  }

  public clearMessages(): void {
    this.messages.set([]);
    this.sessionId.set(null);
    this.conversationGeneration.update((gen) => gen + 1);
  }

  public setSessionId(id: string): void {
    this.sessionId.set(id);
  }

  public setLoading(loading: boolean): void {
    this.loading.set(loading);
  }

  public disableMessage(id: string): void {
    this.messages.update((msgs) =>
      msgs.map((m) => (m.type === 'bot' && m.id === id ? { ...m, disabled: true } : m)),
    );
  }
}
